import css from './LandingTemplatesSection.module.css';
import { TemplatesList } from '@modules/Landing/Components/DesktopLanding/LandingTemplatesSection/TemplatesList/TemplatesList';
import { LandingDIYTemplatesData } from '@modules/Landing/Shared/MockData/LandingDIYTemplatesData';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';

export const LandingTemplatesSection: React.FC = () => {
    const { landingTemplatesInitialization } = useTemplatesViewModel();

    const templatesList = landingTemplatesInitialization(
        LandingDIYTemplatesData
    );

    return (
        <section className={css.section}>
            <TemplatesList templates={templatesList} />
        </section>
    );
};
